export const redirectRoute = (url) => ({
    method: 'GET',
    url: `/integrations/redirect/${url}`
})